// Sidebar kind item. Switched from `s.activeKind` state-walk reads to
// `marketplaceHostOf(el)` so the host is explicit + matches other
// newer components. Label reads `Foo (N)` — count mirrors the
// category-chip pattern (see `kindCount` in functions/index.js).
// Zero-count kinds fade to 0.4 opacity (still clickable for symmetry
// with category chips).

export const MarketplaceKindItem = {
  extends: 'Button',
  width: '100%',
  textAlign: 'left',
  align: 'start',
  padding: 'Z A',
  borderRadius: 'Z',
  background: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return host?.activeKind === el.key ? 'blue.1' : 'transparent'
  },
  color: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return host?.activeKind === el.key ? 'blue' : 'paragraph'
  },
  fontWeight: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return host?.activeKind === el.key ? '600' : '400'
  },
  opacity: (el) => {
    const host = el.call('marketplaceHostOf', el)
    if (host?.activeKind === el.key) return '1'
    const n = el.call('kindCount', host, el.key)
    return n === 0 ? '0.4' : '1'
  },
  text: (el) => {
    const host = el.call('marketplaceHostOf', el)
    const n = el.call('kindCount', host, el.key)
    const label = el.label || el.key
    return `${label} (${n})`
  },
  ':hover': { background: 'line' },

  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    host?.update?.({ activeKind: el.key })
  }
}
